import type React from 'react';
import { useEffect, useRef } from 'react';

import { InspirationalCard } from './inspirational-card';
import { INSPIRATIONAL_CARDS_DATA } from './inspirational-cards-data';
import { StyledRow, Container } from './inspirational-cards-list.styles';

export const InspirationalCardsList: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = (): void => {
      if (containerRef.current && listRef.current) {
        containerRef.current.style.height = `${
          listRef.current.getBoundingClientRect().height
        }px`;
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Container ref={containerRef}>
      <StyledRow ref={listRef}>
        {INSPIRATIONAL_CARDS_DATA.map((data, index) => (
          <InspirationalCard {...data} key={`card-${index}`} />
        ))}
      </StyledRow>
    </Container>
  );
};
